module.exports = __webpack_public_path__ + "static/HORECA2-e25ecd2410ea6ddc140d6233059b12b8.png";